<template>
  <div>
    <v-main>
      <v-row>
        <v-col class="d-none d-md-block auth-col">
          <v-carousel
            cycle
            hide-delimiter-background
            show-arrows-on-hover
            height="100vh"
            class="pa-0"
          >
            <v-carousel-item>
              <v-sheet color="primary" height="100%">
                <v-row class="fill-height" align="center" justify="center">
                  <div class="d-flex flex-column" style="margin-left: 15%">
                    <v-img
                      class="mx-2  mb-8"
                      src="/img/vehicle.svg"
                      max-width="250"
                    ></v-img>
                    <p class="text-left custom-title">
                      Let us deliver for you…
                    </p>
                    <p class="underline-secondary"></p>
                    <p class="text-left custom-text">
                      We have a reputation of delivering packages all over the
                      world with extreme efficiency and with utmost dedication.
                    </p>
                  </div>
                </v-row>
              </v-sheet>
            </v-carousel-item>
            <v-carousel-item>
              <v-sheet color="#01288d" height="100%">
                <v-row class="fill-height" justify="center" align="center">
                  <div class="d-flex flex-column" style="margin-left: 15%">
                    <v-img
                      class="mx-2 mb-8"
                      src="/img/location.svg"
                      max-width="250"
                    ></v-img>
                    <p class="text-left custom-title">At your doorstep…</p>
                    <p class="underline-secondary"></p>
                    <p class="text-left custom-text">
                      We have a reputation of delivering packages all over the
                      world with extreme efficiency and with utmost dedication.
                    </p>
                  </div>
                </v-row>
              </v-sheet>
            </v-carousel-item>
            <v-carousel-item>
              <v-sheet color="#01288d" height="100%">
                <v-row class="fill-height" justify="center" align="center">
                  <div class="d-flex flex-column" style="margin-left: 15%">
                    <v-img
                      class="mx-2  mb-8"
                      src="/img/vehicle.svg"
                      max-width="250"
                    ></v-img>
                    <p class="text-left custom-title">
                      Let us deliver for you…
                    </p>
                    <p class="underline-secondary"></p>
                    <p class="text-left custom-text">
                      We have a reputation of delivering packages all over the
                      world with extreme efficiency and with utmost dedication.
                    </p>
                  </div>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-col>
        <v-col cols="12" md="5">
          <router-view />
        </v-col>
      </v-row>
    </v-main>

    <v-overlay opacity="0.5" :value="loading">
      <v-progress-circular indeterminate size="64">
        Loading...
      </v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "Auth",
  data: () => ({
    loading: false,
    color: "deep-purple accent-4"
  }),
  mounted() {
    Event.$on("loading", value => {
      this.loading = value;
    });
  }
};
</script>

<style>
.auth-col {
  padding: 0 !important;
}
.custom-title {
  font-weight: 700 !important;
  font-family: inherit !important;
  font-size: 2.5rem;
}

.custom-text {
  font-family: inherit !important;
  font-size: 1.4rem;
  width: 50%;
}

.underline-secondary {
  width: 10rem;
  border-radius: 0.2rem;
  height: 0.3rem;
  background-color: #f8d407;
}
</style>
